import api from '@/services/Api';

class RentalManufacturerService {

  async getManufacturerListByRepairFileBoomerangId(repairFileBoomerangId) {
    const response =
      await api.get('rental/distributor/manufacturer/list/' + repairFileBoomerangId)
    return response.data
  }

  async getDefaultManufacturerByRepairFileBoomerangId(repairFileBoomerangId) {
    const response =
      await api.get('rental/distributor/manufacturer/' + repairFileBoomerangId)
    return response.data
  }
}

export default new RentalManufacturerService()
